import React from 'react';
import { Stack } from '@mui/material';
import AccordionPolicyItem from '../AccordionPolicyItem/AccordionPolicyItem';
import { IPolicy } from '../../types/policies-types';

const PoliciesAccordion: React.FC<
  React.PropsWithChildren<IPoliciesAccordionProps>
> = ({ policies }) => {
  return (
    <Stack
      minWidth='100%'
      maxHeight={500}
      overflow='auto'
      flexGrow={1}
      spacing={0.1}
      direction='column'>
      {policies.map(p => (
        <AccordionPolicyItem key={p.id} policy={p} />
      ))}
    </Stack>
  );
};
export interface IPoliciesAccordionProps {
  policies: IPolicy[];
}

export default PoliciesAccordion;
